import styled, { css } from 'styled-components';
import { sizes } from 'style';
import { StyledButton } from '../../styled';

export const StyledClaimNoteButton = styled(StyledButton)`
  white-space: nowrap;

  ${({ disabled }) =>
    disabled &&
    css`
      display: none;

      @media ${sizes.tabletPortrait} {
        display: flex;
      }
    `};
`;
